var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-layout',[_c('h1',{staticClass:"black--text my-3",attrs:{"slot":"title"},slot:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('CONFIGURAR NUEVA CONTRASEÑA'))+"\n  ")]),_c('template',{slot:"content"},[_c('reset-new-password-form')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }